import { render, staticRenderFns } from "./DoubleScrollbar.vue?vue&type=template&id=53dc1849&scoped=true"
import script from "./DoubleScrollbar.vue?vue&type=script&lang=js"
export * from "./DoubleScrollbar.vue?vue&type=script&lang=js"
import style0 from "./DoubleScrollbar.vue?vue&type=style&index=0&id=53dc1849&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc1849",
  null
  
)

export default component.exports